import { combineReducers } from 'redux'
import userReducer from './userReducer'
import notificationReducer from './notificationReducer'
import evaluationReducer from './evaluationReducer'
import productsReducer from './productsReducer'
import billingAndBlockStatusReducer from './billingAndBlockStatusReducer'

const rootReducer = combineReducers({
  userReducer,
  notificationReducer,
  evaluationReducer,
  productsReducer,
  billingAndBlockStatusReducer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js